import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../../localization/react'
import { PaymentMethod } from '../../typings/Payment'
import PaymentMethodIcon from './PaymentMethodIcon'

import poweredByStripeImg from './img/powered-by-stripe.svg'

const useStyles = makeStyles(({ layoutSpacing }: Theme) => ({
  root: {
    padding: layoutSpacing.default,
  },
  img: {
    height: 22,
  },
}))

interface Props {
  paymentMethods: Array<PaymentMethod>
}

const AvailablePaymentMethodsComponent: React.FC<React.PropsWithChildren<Props>> = ({ paymentMethods }) => {
  const classes = useStyles()

  return (
    <Flex flexDirection="column" className={classes.root}>
      <Flex justifyContent="space-between">
        <Text is="div" marginBottom="dense">
          <Localized id="payment-provider-title" />
        </Text>
        <img src={poweredByStripeImg} alt="Powered by Stripe" className={classes.img} />
      </Flex>
      <Flex alignItems="center" flexWrap="wrap" horizontalSpacing="wide">
        {paymentMethods.map((paymentMethod) => (
          <PaymentMethodIcon key={paymentMethod.type} paymentMethodType={paymentMethod.type} size="xx-large" />
        ))}
      </Flex>
    </Flex>
  )
}

export default React.memo(AvailablePaymentMethodsComponent)
